export const HELP_FAQ_ENTRIES_URL = '/help'
export const HELP_SEARCH_URL = '/help/s'
